/**
 * Turns an Orderful validation-error dataPath like
 * "transactionSets.0.HL_loop.0.N1_loop.0.geographicLocation.0.stateOrProvinceCode"
 * into a readable field name ("stateOrProvinceCode") plus a breadcrumb trail
 * ("transactionSets[0] › HL_loop[0] › N1_loop[0] › geographicLocation[0]").
 *
 * Numeric path segments are folded into the preceding segment as array indices.
 */
export function describeEdiDataPath(dataPath?: string | null): {
  field: string | null;
  trail: string | null;
} {
  if (!dataPath) {
    return { field: null, trail: null };
  }

  const segments = dataPath.split('.');
  const parts: string[] = [];
  for (const segment of segments) {
    if (/^\d+$/.test(segment)) {
      if (parts.length > 0) {
        parts[parts.length - 1] += `[${segment}]`;
      }
    } else {
      parts.push(segment);
    }
  }

  if (parts.length === 0) {
    return { field: null, trail: null };
  }

  // Strip any trailing bracket index (e.g. "HL_loop[0]" → "HL_loop") so the
  // field title stays clean even when the path ends with an array index.
  // Real Orderful dataPaths end in a named field, but this keeps the helper
  // robust for paths that point at an array element.
  const field = parts[parts.length - 1].replace(/\[\d+\]$/, '');
  const trailParts = parts.slice(0, -1);
  return {
    field,
    trail: trailParts.length > 0 ? trailParts.join(' › ') : null,
  };
}
